import { useState } from "react"

// libraries
import { Tooltip } from "@mui/material"
import ClickAwayListener from "react-click-away-listener"

// images
import chatImage from "@/assets/img/header/icons/chat.svg"

// providers
import { useMessagesContext } from "@/_providers/Messages"
import { trans } from "@/_providers/Translation"

// components
import Messages from "@/components/app/modules/Messages"

export default function ChatInHeader() {
  const messages = useMessagesContext()

  const [visible, setVisible] = useState(false)

  return (
    <ClickAwayListener onClickAway={() => setVisible(false)}>
      <>
        <Tooltip
          title={messages.count ? trans('random.newMessages').replace('{count}', messages.count) : ""}
          arrow
          placement="bottom-end"
        >
          <div className="icon" onClick={() => setVisible(true)}>
            {messages.count > 0 && <span></span>}
            <img src={chatImage} alt="messages" />
          </div>
        </Tooltip>

        {visible ? <Messages /> : <></>}
      </>
    </ClickAwayListener>
  )
}
